import 'intersection-observer';
import PropTypes from 'prop-types';
import React from 'react';
import BUSINESS_TYPE from '../../constants/businessType';
import useInitLibsNative from '../../hooks/useInitLibsNative';
import useTrackFlags from '../../hooks/useTrackFlags';
import State from '../../models/State';
import { SessionService } from '../../server/services';
import { getAppVersion, getLocale, getPlatform } from '../../server/utils';
import View from '../../views/detail-channel';

export default function DetailChannel(props) {
  // Init @tracker && @fwf
  const { fwfConfig, trackerConfig, flags = {} } = props;

  useTrackFlags(flags);

  useInitLibsNative(fwfConfig, trackerConfig);

  return <View {...props} />;
}

DetailChannel.propTypes = {
  fwfConfig: PropTypes.shape({
    config: PropTypes.shape({}),
    context: PropTypes.shape({}),
  }),
  trackerConfig: PropTypes.shape({
    historicalEnabled: PropTypes.bool,
  }),
};

export async function getServerSideProps({ res, req, query }) {
  const { token, ...queryParams } = query;
  // From Session
  const headers = SessionService.getGlobalHeaders(req) || {};
  const country = SessionService.getCountry(req) || {};
  const landing = SessionService.getLanding(req) || {};
  const user = SessionService.getUser(req);
  const vendorChain = SessionService.getVendorChain(req || []);
  const location = SessionService.getLocation(req);
  const { latitude: lat, longitude: lng } = location;
  const passport = SessionService.getPassport(req);
  const env = SessionService.getEnv(req);
  const { locals } = res;

  // From Request
  const { bt, c, origin, bannerid, banner_name: bannerName } = queryParams;
  const currentVersion = getAppVersion(req);
  const currentPlatform = getPlatform(req);
  const locale = getLocale(country);
  const userAgent = req?.headers['user-agent'] || req?.headers['User-Agent'];
  const isDesktop = /Macintosh|Windows/.test(userAgent);
  const DESKTOP = 'desktop';

  const countryMessages = (await import(`../../translations/${locale}.json`))
    .default;
  const defaultMessages = (await import(`../../translations/base.json`))
    .default;

  const messages = { ...defaultMessages, ...countryMessages };

  if (currentPlatform !== 'unknown')
    SessionService.savePlatform(req, currentPlatform);

  const platformInSession = SessionService.getPlatform(req);

  let platform;

  if (platformInSession === 'ios' || platformInSession === 'android') {
    platform = platformInSession;
  } else if (isDesktop) {
    platform = DESKTOP;
  } else {
    platform = currentPlatform;
  }

  const initialState = State({
    appVersion: currentVersion,
    platform,
    user,
    location,
    country,
    landing,
    countryId: c,
    searchQueryParams: queryParams,
    lat,
    lng,
    origin,
    headers,
    bannerid,
    bannerName,
    vendorChain,
    isDesktop,
    passport,
    env,
    fenixVersion: locals?.fenixVersion,
  });

  const cleanProps = JSON.parse(
    JSON.stringify({
      initialState,
      trackerConfig: {
        historicalEnabled: true,
      },
      fwfConfig: {
        platform: currentPlatform,
        config: {
          appVersion: currentVersion,
        },
        context: {
          email: user?.email || '',
          userId: user?.id || '',
          country: country?.shortName || '',
          businessType: bt || BUSINESS_TYPE.RESTAURANT,
          isWebView: true,
          version: currentVersion,
          platform: currentPlatform,
        },
      },
      i18n: {
        locale,
        messages,
      },
      flags: locals?.flags || {},
    }),
  );

  return {
    props: cleanProps,
  };
}
